import IPDNav from "../../pages/Dashboard/IPD/IPDNav";
import IPDDashboard from "../../pages/Dashboard/IPD/IPDDashboard";
import AdmissionsList from "../../pages/Dashboard/IPD/Admissions/AdmissionsList";
import NewAdmission from "../../pages/Dashboard/IPD/Admissions/NewAdmission";
import AdmissionView from "../../pages/Dashboard/IPD/Admissions/AdmissionView";
import WardRoundsList from "../../pages/Dashboard/IPD/WardRounds/WardRoundsList";
import MedicalEquipmentPage from "../../pages/Dashboard/IPD/MedicalEquipment/MedicalEquipmentPage";

const IPDRoutes = {
  path: "/ipd",
  element: <IPDNav />,
  children: [
    { path: "/ipd", element: <IPDDashboard /> },
    { path: "/ipd/admissions", element: <AdmissionsList /> },
    { path: "/ipd/admissions/new", element: <NewAdmission /> },
    { path: "/ipd/admissions/:id", element: <AdmissionView /> },
    { path: "/ipd/admissions/:id/edit", element: <NewAdmission /> },
    { path: "/ipd/ward-rounds", element: <WardRoundsList /> },
    { path: "/ipd/medical-equipment", element: <MedicalEquipmentPage /> },
  ],
};

export default IPDRoutes;
